import { mount, type Component } from 'svelte';
import Down from './Down.svelte';

// The browser's part of a catalogue page (UC-30, UC-31). The catalogue's
// worker renders the whole page; the parts that act are marked data-island
// with their props, and are mounted here over their own server-rendered
// markup, which is replaced, not hydrated, so nothing but these few props
// reaches the browser as data. The item sheet takes each item's body from
// the markup itself, never as props.
//
// When the worker did not run, because Cloudflare served a static file once
// the day's allowance was spent, there is no rendered page at all, and the
// page that asks the diner to try again later is drawn instead.

// The island components take different props; each reads its own.
type Island = Component<never>;

export function startIslands(islands: Record<string, Island>): void {
	const app = document.getElementById('app');
	if (!app) throw new Error('the mount point #app is missing');
	if (!app.querySelector('[data-page]')) {
		app.replaceChildren();
		mount(Down, {
			target: app,
			props: { ownersHref: '/', retryHref: location.pathname + location.search },
		});
		return;
	}
	for (const target of app.querySelectorAll<HTMLElement>('[data-island]')) {
		const island = islands[target.dataset.island ?? ''];
		if (!island) continue;
		const props = JSON.parse(target.dataset.props ?? '{}') as never;
		target.replaceChildren();
		mount(island, { target, props });
	}
}
